<template>
  <section>
    <AccountPopup
      :pageName="gameName"
      :pwOperation="pwOperation"
      :showPopup="showPwSettingPopup"
      @switchPopup="onSwitchPopup"
      @onPopupClosed="onPopupClosed"
      @firstCreatePassword="onFirstCreatePassword"
    />
    <PayPopup
      v-model="showPayPasswordPanel"
      :from="gameName"
      ref="payPopup"
      @retreivePassword="retreivePassword"
      @createOrder="createWalletOrder"
      @resetPayPopupStatus="resetPayPopupStatus"
      @queryAccountInfo="queryAccountInfo"
    />
    <Recharge
      v-model="showRecharge"
      ref="rechargeRef"
      :walletBalance="walletBalance"
      :isFirstPay="isFirstPay"
      :couponPayPrice="couponPayPrice"
      :closeRecharge="closeRecharge"
    />
    <RechargeGuide
      v-model="showRechargeGuide"
      :type="popupType"
      @active="handleActive"
      :walletBalance="walletBalance"
      :detailChannelList="detailChannelList"
      :realPayPrice="realPayPrice"
      :couponPayPrice="couponPayPrice"
    />
    <RechargeGuideBySuccess
      @gotoPay="gotoPay"
      :walletBalance="walletBalance"
      :detailChannelList="detailChannelList"
      :realPayPrice="realPayPrice"
      :couponPayPrice="couponPayPrice"
    />
    <WalletRechargeGuide ref="balancePopup" :accountBalance="walletBalance" />
  </section>
</template>
<script>
  import { mapActions, mapMutations, mapState } from 'vuex'
  import { checkPasswordIsSet } from '@/api/coin.js'
  import { trackWalletPaidResult } from '@/pages/Wallet/firebase.js'
  import AccountPopup from '@/components/WalletAccountPopup'
  import PayPopup from './components/Pay'
  import Recharge from './components/recharge/Recharge'
  import RechargeGuide from './components/guide/RechargeGuide'
  import RechargeGuideBySuccess from './components/guide/RechargeGuideBySuccess'
  import WalletRechargeGuide from './components/PayResult'
  import { storage, firstCreatePassword } from '@/utils/storage'
  import { TopLupe_WalletName } from '../config'
  // 钱包支付
  export default {
    name: 'wallet-popup',
    props: {
      gotoOrder: {
        default: false,
        type: Boolean,
      },
      readyToSubmit: {
        default: false,
        type: Boolean,
      },
      couponPayPrice: {
        default: 0,
        type: [Number, String],
      },
      realPayPrice: {
        default: 0,
        type: [Number, String],
      },
      detailChannelList: {
        default: () => [],
        type: Array,
      },
    },
    components: {
      PayPopup,
      Recharge,
      AccountPopup,
      RechargeGuide,
      RechargeGuideBySuccess,
      WalletRechargeGuide,
    },
    data() {
      return {
        showPayPasswordPanel: false,
        pwIsSet: false,
        showPwSettingPopup: false,
        pwFilled: false, // 标记密码是否填充
        showRecharge: false, // 是否展示充值弹窗
        showRechargeGuide: false, // 是否展示引导弹窗（激活弹窗/引导弹窗）
        selectedSku: {},
        isFirstPay: !!storage.get(firstCreatePassword),
      }
    },
    computed: {
      ...mapState([
        'gameName',
        'createOrderState',
        'selectedPaymentInfo',
        'userInfo',
        'paymentAccountInfo',
        'isApp',
      ]),
      pwOperation() {
        return !this.pwIsSet ? 'initPW' : 'resetPW'
      },
      popupType() {
        // 弹窗类型
        // 余额不足：激活弹窗；余额充足：引导弹窗
        return this.walletBalance < this.couponPayPrice ? 'active' : 'guide'
      },
      walletBalance() {
        // 钱包余额
        return (this.paymentAccountInfo && this.paymentAccountInfo.amount) || 0
      },
      abTestIsOld() {
        // ab test 是否是原有钱包交互流程
        // 倒数第3位为奇数（1、3、5、7、9）默认展示「钱包交互2.0」
        // 倒数第3位为偶数（2、4、6、8、0）默认展示「原有钱包交互」
        // const { kicoinId = '' } = this.userInfo || {}
        // const number = (kicoinId + '').slice(-3, -2) * 1
        // return number % 2 === 0
        return true
      },
    },
    watch: {
      showPayPasswordPanel(val) {
        if (!val) {
          this.pwfilled = false
          this.$emit('setEncodedPw', '')
        }
      },
    },
    mounted() {},
    methods: {
      ...mapActions(['getWalletBalance']),
      ...mapMutations(['setCreateOrderState', 'setPaymentAccountInfo']),
      login(res) {
        this.loginResult(res)
        this.$refs.rechargeRef && this.$refs.rechargeRef.login(res)
      },
      loginResult(res) {
        // 一旦登录即刻获取钱包余额并判断是否设置钱包密码
        Promise.all([
          this.getWalletBalance(),
          this.checkPayPwSetOrNot(res.userInfo),
        ])
          .then(() => {
            if (this.gotoOrder) {
              this.$emit('gotoPay')
            }
          })
          .catch()
      },
      queryAccountInfo() {
        this.getWalletBalance()
        this.checkPayPwSetOrNot(this.userInfo)
      },
      async checkPayPwSetOrNot(userInfo) {
        // 查询是否设置钱包密码
        const { kicoinId } = userInfo
        try {
          const data = await checkPasswordIsSet({
            userId: kicoinId,
          })
          const { result } = data
          this.pwIsSet = result
          return Promise.resolve(result)
        } catch (e) {
          this.pwIsSet = 'error'
          return Promise.reject('error')
        }
      },
      displayWarningPopup(type) {
        this.$refs.payPopup && this.$refs.payPopup.displayNoticePopup(type)
      },
      // 检查钱包是否准备好支付
      checkWalletReadyToPay() {
        // 原始逻辑
        if (this.abTestIsOld) {
          // 账户冻结时直接弹窗提醒
          const { status } = this.paymentAccountInfo || {}
          if (status === 2) {
            this.displayWarningPopup('frozen')
            return false
          }
          // 1. 余额不足时直接弹窗（不区分是否绑定密码）
          if (this.walletBalance < this.couponPayPrice) {
            this.handleInsufficientBalance()
            return false
          }
          // 2. 检验钱包密码是否设置
          if (this.pwIsSet === 'error') {
            // 请求有问题或者接口返回异常
            return false
          } else if (this.pwIsSet === false) {
            // 接口正常返回：用户未设置密码，弹出密码绑定弹窗
            this.showPwSettingPopup = true
            return false
          }
          // 3. 若设置了支付密码则调起密码输入键盘
          if (!this.pwFilled && this.readyToSubmit) {
            this.showPayPasswordPanel = true
            return false
          }
          return true
        }
        // 优化的逻辑
        // 检测钱包密码设置是否异常
        if (this.pwIsSet === 'error') {
          // 请求有问题或者接口返回异常
          return false
        }
        if (this.walletBalance < this.couponPayPrice * 1) {
          this.setCreateOrderState('error')
          if (this.pwIsSet === false) {
            // 余额不足，未绑定密码：激活弹窗
            this.showRechargeGuide = true
          } else {
            // 余额不足，绑定密码：充值弹窗
            this.showRecharge = true
          }
          return false
        }
        // 2. 余额充足，未设置密码：引导弹窗
        if (this.pwIsSet === false) {
          this.showRechargeGuide = true
          return false
        }
        // 3. 余额充足，若设置了支付密码则调起密码输入键盘
        if (!this.pwFilled && this.readyToSubmit) {
          this.showPayPasswordPanel = true
          return false
        }
        return true
      },
      orderCatch(e) {
        const { code } = e
        switch (String(code)) {
          case '20009':
            if (this.abTestIsOld) {
              this.handleInsufficientBalance()
            } else {
              this.checkWalletReadyToPay()
            }
            break // 余额不足
          case '21001':
            this.displayWarningPopup('error')
            break // 支付密码校验失败，5次以内展示密码错误弹窗
          case '20002':
            this.displayWarningPopup('frozen')
            break // 账户已冻结，提示弹窗
          case '21004':
            this.displayWarningPopup('errorLimit')
            break // 连续输错次数达到上限
          case '20013': //24小时内消费频次过高
          case '20014': //24小时内消费金额过高
            this.displayWarningPopup('appeal')
            break
          default:
            this.$refs.payPopup && (this.$refs.payPopup.show = false)
            break
        }
        this.resetPayPopupStatus() // 报错之后务必重置输入密码
        const { payMethodName = '' } = this.selectedPaymentInfo || {}
        if (payMethodName === TopLupe_WalletName) {
          trackWalletPaidResult({
            page: this.gameName,
            code,
          })
        }
      },
      handleActive() {
        // 激活账号
        this.showRechargeGuide = false
        this.showPwSettingPopup = true
      },
      onSwitchPopup(val) {
        this.showPwSettingPopup = val
      },
      onFirstCreatePassword() {
        // 首次设置密码
        storage.set(firstCreatePassword, 'true')
      },
      retreivePassword() {
        this.showPwSettingPopup = true
      },
      onPopupClosed(data) {
        // 关闭弹窗
        this.isFirstPay = storage.get(firstCreatePassword)
        if (typeof data === 'object' && data.request) {
          Promise.all([
            this.getWalletBalance(),
            this.checkPayPwSetOrNot(this.userInfo),
          ])
            .then(() => {
              this.abTestIsOld
                ? this.$emit('onCheckWalletReadyToPay')
                : this.checkWalletReadyToPay()
            })
            .catch(() => {
              this.setCreateOrderState('error')
            })
        } else {
          // 终止交易
          this.setCreateOrderState('error')
        }
      },
      handleInsufficientBalance() {
        // 余额不足
        this.setCreateOrderState('error')
        if (this.$refs.balancePopup) {
          this.$refs.balancePopup.show = true
        }
      },
      resetPayPopupStatus() {
        this.pwFilled = false
      },
      async createWalletOrder(data) {
        if (data && data.encodedPw) {
          this.$emit('setEncodedPw', data.encodedPw)
        }
        this.pwFilled = true
        this.$emit('gotoPay')
      },
      gotoPay() {
        // 去支付
        this.checkWalletReadyToPay()
      },
      // end
      // app内，跳转收银台前重置状态
      appResetWallet() {
        this.showPayPasswordPanel = false
        this.showPwSettingPopup = false
        this.pwFilled = false
      },
      // 关闭充值弹窗
      closeRecharge() {
        this.showRecharge = false
      },
    },
  }
</script>
